import React from 'react';
import { shape, string } from 'prop-types';
import BasePage from '../BasePage/BasePage';
import BasePageUAM from '../BasePageUAM/BasePageUAM';
import NotFoundPanel from './Panels/NotFoundPanel';
import { redirectToUAM } from '../../destructured-front-end-config';

const basePageAndExtraSettings = redirectToUAM
  ? {
    SelectedBase: BasePageUAM,
    extraSettings: {
      showTabs: false,
    },
  }
  : {
    SelectedBase: BasePage,
    extraSettings: {},
  };

const { SelectedBase, extraSettings } = basePageAndExtraSettings;

const NotFoundPage = ({ title, error, brand }) => (
  <SelectedBase brand={brand} {...extraSettings}>
    <NotFoundPanel title={title} error={error} brand={brand} />
  </SelectedBase>
);

NotFoundPage.propTypes = {
  title: string.isRequired,
  error: string,
  brand: shape({
    short: string.isRequired,
    full: string.isRequired,
  }).isRequired,
};

NotFoundPage.defaultProps = {
  error: 'pageNotFound',
};

export default NotFoundPage;
